"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globals_1 = require("models/globals");
const webix_jet_1 = require("webix-jet");
const formFields_1 = require("models/formFields");
const aide_1 = require("views/aide");
// import {langue,organisation} from "./parametres";
class Login extends webix_jet_1.JetView {
    config() {
        const nbtField = { view: "template", template: "", height: 50, borderless: true, id: "nbtField" };
        const form = {
            id: "loginForm", view: "form", scroll: false, width: 400,
            align: "left",
            // paddingX : 200,
            localId: "login:form",
            elements: [
                formFields_1.emailField,
                formFields_1.motdepasseField,
                { view: "label" },
                {
                    rows: [
                        {
                            margin: 5,
                            cols: [
                                { view: "button", value: (0, globals_1._)("Connexion"), css: "webix_primary", id: "connexionButton",
                                    click: () => this.connecter(), hotkey: "enter"
                                },
                                { view: "button", value: (0, globals_1._)("Annuler"),
                                    click: () => this.annuler()
                                },
                                { view: "button", value: (0, globals_1._)("Aide"),
                                    click: () => this.sos()
                                }
                            ]
                        },
                        nbtField,
                        {
                            view: "button", value: (0, globals_1._)("Demander un nouveau mot de passe"), hidden: false,
                            id: "buttonDemande", click: () => this.demande()
                        }, {
                            view: "template", borderless: true, hidden: false, localId: "demande",
                            template: (0, globals_1._)("Indiquez votre adresse e-mail dans le champ identifiant pour demander un nouveau mot de passe."),
                            height: 50
                        }
                    ]
                }
            ],
            rules: {
                identifiant: webix.rules.isNotEmpty,
                motdepasse: webix.rules.isNotEmpty
            }
        };
        return {
            view: "window",
            id: "loginWindow",
            // @ts-ignore
            head: organisation,
            // modal:true,
            position: "center",
            body: form
        };
    }
    sos() {
        if (!this.aide) {
            // @ts-ignore
            this.aide = this.ui(aide_1.default);
        }
        this.aide.showHelp();
        const optionMenu = "Premiere_Connexion";
        this.aide.load(optionMenu);
    }
    demande() {
        let emailField = this.$$("emailField");
        let email = emailField.getValue();
        // @ts-ignore
        if (!webix.rules.isEmail(email)) {
            webix.alert((0, globals_1._)("L'adresse e-mail n'est pas valide."));
            return;
        }
        webix.alert((0, globals_1._)("Le traitement de votre demande en cours ..."));
        // @ts-ignore
        webix.ajax().post(globals_1.phpPath + "login.php?option=nouveauMotDePasse", {
            identifiant: emailField.getValue()
        }).then(function (result) {
            // console.log(result.json().success);
            // console.log(result.json().message);
            if (!result.json().success) {
                webix.alert({
                    text: (0, globals_1._)("Votre demande pour modifier votre mot de passe n'a pas abouti"),
                }).then(function () {
                    window.location.href = "#!/login";
                });
            }
            webix.alert({
                text: (0, globals_1._)("Vous allez recevoir un message avec un lien pour modifier votre mot de passe"),
            }).then(function () {
                window.location.href = "#!/login";
            });
        }).catch(function () {
            webix.alert({
                text: ((0, globals_1._)("Votre demande pour modifier votre mot de passe n'a pas abouti")),
            }).then(function () {
                window.location.href = "#!/login";
            });
        });
    }
    connecter() {
        const form = this.$$("login:form");
        // const me = this;
        // @ts-ignore
        if (form.validate()) {
            // @ts-ignore
            const data = form.getValues();
            // @ts-ignore
            webix.ajax().post(globals_1.phpPath + "login.php?option=standard", {
                identifiant: data.identifiant,
                motdepasse: data.motdepasse
            }).then(result => {
                if (result.json().success === true) {
                    const langue = result.json().langue;
                    // @ts-ignore
                    this.app.use(webix_jet_1.plugins.Locale, { lang: langue });
                    // _ = me.app.getService("locale")._;
                    window.location.href = "#!/pgiLayout/start";
                    return;
                }
                else {
                    this.noaccess(result.json().message);
                }
            });
        }
    }
    noaccess(message) {
        webix.alert({
            text: (message),
            type: "error",
            expire: 5000
        });
        this.count = this.count - 1;
        $$("buttonDemande").show();
        // @ts-ignore
        this.$$("demande").show();
        if (this.count === 0) {
            $$("connexionButton").disable();
        }
        // @ts-ignore
        $$("nbtField").setHTML(this.count + " tentatives restantes");
    }
    annuler() {
        window.location.href = "http://first.alnitac.com";
    }
    init(view) {
        this.count = 0;
        // this.app.use(plugins.Theme);
        // this.theme = this.app.getService("theme");
        // this.theme.setTheme("material");
        this.count = 5;
        $$("loginWindow").show();
        // @ts-ignore
        webix.ajax().get(globals_1.phpPath + "statut.php?option=statut").then(function (data) {
            if (!data.json().success) {
                let msg = this.app.getService("locale")._("L'application n'est pas disponible pour le motif : ");
                msg = msg + data.json().motif + "</br>";
                msg = msg + this.app.getService("locale")._("La réouverture est prévue pour : ");
                msg = msg + data.json().fin;
                webix.alert(msg).then(() => {
                    window.location.href = "";
                });
            }
        });
        view.$view.querySelector("input").focus();
    }
}
exports.default = Login;
